<script setup lang="ts">
// [FIXME]
// 色を指すもの(darkとか)と、セマンティックなものが混ざっている。
// セマンティックな名前のみにしたいね(Colorというpropsもvariantとかになりそう)
type Color = 'none' | 'primary' | 'success' | 'danger' | 'dark' | 'primary-light' | 'inactive'

type Props = {
  text?: string | null
  color?: Color
  size?: 'medium' | 'large'
  disabled?: boolean
}

withDefaults(defineProps<Props>(), {
  text: '',
  color: 'none',
  size: 'medium',
  disabled: false,
})

const emit = defineEmits(['click'])
</script>

<template>
  <button
    class="base-button"
    :class="{
      large: size === 'large',
      medium: size === 'medium',
      [color]: true,
      disabled,
    }"
    :disabled="disabled"
    @click.stop="emit('click')"
  >
    <span v-if="text">{{ text }}</span>
  </button>
</template>

<style scoped lang="scss">
.base-button {
  @include textToken.label-large;

  cursor: pointer;
  background-color: transparent; // bulmaスタイルの打ち消し
  border-radius: 4px;
  padding-right: spacingToken.$spacing-m;
  padding-left: spacingToken.$spacing-m;
  border: none;
  box-shadow: none;
  text-wrap: nowrap;
  min-width: 88px;

  &:not(.disabled):hover {
    opacity: 0.9;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }

  &.danger {
    color: var(--semantic-tokens-inverse-default-text);
    background-color: var(--semantic-tokens-danger-strong-surface);
  }

  &.success {
    color: var(--semantic-tokens-inverse-default-text);
    // TODO: surface系に変更する
    background-color: var(--semantic-tokens-success-default-text);
  }

  &.primary {
    color: var(--semantic-tokens-inverse-default-text);
    background-color: var(--semantic-tokens-brand-strong-surface);
  }

  &.primary-light {
    color: var(--semantic-tokens-inverse-default-text);
    // TODO: brand系の色を使う
    background-color: var(--semantic-tokens-success-default-surface);
    border: none;
  }

  &.dark {
    color: var(--semantic-tokens-inverse-default-text);
    background-color: var(--semantic-tokens-neutral-strong-surface);
    border: none;
  }

  &.inactive {
    color: var(--semantic-tokens-neutral-weak-text);
    // TODO: border系の色に変更する
    border: 1px solid var(--semantic-tokens-neutral-strong-surface);
  }

  &.none {
    border: 1px solid var(--semantic-tokens-neutral-strong-border);
  }

  &.medium {
    height: 40px;
  }

  &.large {
    height: 48px;
  }
}
</style>
